export default __webpack_public_path__ + "static/media/amaze-2.de46257a.jpg";